import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/authentication/service';
import { AuthGuard } from 'app/authentication/helpers/auth.guards';

@Component({
  selector: 'app-landing-redirect',
  template: '',
})
export class LandingRedirectComponent implements OnInit {
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    const currentUser = this._authenticationService.currentUserValue;

    if (!currentUser) {
      this._router.navigate(['/authentication/login']);
      return;
    }

    const target = AuthGuard.findFirstAccessibleRoute(currentUser);
    if (target) {
      this._router.navigate([target]);
    } else {
      this._authenticationService.logout();
    }
  }
}
